
export const isEmpty = obj => Object.keys(obj).length === 0;

export const  keysToLowerCase =obj=> {
    const lowerCaseObject = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
        lowerCaseObject[lowerCaseKey] = obj[key];
      }
    }
    return lowerCaseObject;

}
export const keysToCamelCase = (obj) => {
    return Object.keys(obj).reduce((accumulator, currentKey) => {
        const camelCaseKey = toCamelCase(currentKey);
        accumulator[camelCaseKey] = obj[currentKey];
        return accumulator;
    }, {});
}
export function toCamelCase(str) {
    // Split the string into words
    const words = str.split(/[-_]/);

    // Capitalize the first letter of each word, except the first one,
    // make the rest of the word lowercase
    return words.map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }

        return word[0].toUpperCase() + word.slice(1).toLowerCase();
    })
        // Join all the words into a string
        .join('');
}

export function ensureArray(value) {
    return Array.isArray(value) ? value : [];
}